import React from "react";
import { Form } from "antd";
import IntegerDecimalInput from "../IntegerDecimalInput"; // adjust path if needed

const FormItemDecimalInput = ({
  label,
  name,
  rules = [],
  placeholder = "Enter value",
  maxLength,
  disabled = false,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <IntegerDecimalInput
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default FormItemDecimalInput;
